import RetailerAvatar from './RetailerAvatar';

export type RetailerListItem = {
  id: string;
  name: string;
};

type RetailerListProps = {
  items: RetailerListItem[];
  selectedId?: string | null;
  onSelect: (id: string) => void;
};

const RetailerList: React.FC<RetailerListProps> = ({
  items,
  selectedId,
  onSelect,
}) => {
  return (
    <div className="divide-y divide-secondary-grey overflow-y-auto custom-scrollbar flex flex-col h-[500px]">
      {items.map((item) => (
        <div key={item.id}>
          <button
            type="button"
            onClick={() => onSelect(item.id)}
            className={`w-full flex items-center gap-1-0 text-left hover:bg-secondary-grey/60 text-body1 font-md p-2-0 ${
              selectedId && item.id === selectedId ? 'bg-secondary-grey/60' : ''
            }`}
            data-testid={`retailer_${item.id}`}
          >
            <RetailerAvatar
              id={item.id}
              name={item.name}
              sizeClass="w-3-2 h-3-2"
            />
            <span className="text-primary-black">{item.name}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default RetailerList;
